'use es6';

import { createStack } from 'hub-http';
import * as core from 'hub-http/middlewares/core';
import * as hubapi from 'hub-http/middlewares/hubapi';
import * as debug from 'hub-http/middlewares/debug';
import promiseClient from 'hub-http/adapters/promiseClient';
import hubletApiResult from './determineHublet';
export default promiseClient(createStack(core.services, hubapi.defaults, debug.allowTimeoutOverride, core.jsonBody, core.httpsOnly,
/*
 * This next line replaces the hubapi.hubapi from the standard implementation of
 * the noAuthClient to handle the custom domains this app is hosted on which follow the pattern:
 * www.hubspot{free|starter}{qa?}-{shard}-{hublet}.net
 * https://git.hubteam.com/HubSpot/hub-http/blob/master/static/js/stacks/noAuthWithCredentialsHubapi.js#L14
 */
core.environmentUrl(hubletApiResult), core.withQuery, debug.rewriteUrl, core.reportOptionsError, hubapi.retryOnError, core.validateStatus, core.jsonResponse));